import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { BudgetUsageSection } from '@/components/dashboard/BudgetUsageSection';
import { useAppDateRange } from '@/contexts/AppDateRangeContext';
import { parseCampaignsPayload } from '@/utils/entityCrossFilter';
import { adsApi } from '@/api/client';
import { isRangeValid } from '@/api/reportDateRanges';

export function BudgetUsagePage() {
  const { profileId: profileIdParam } = useParams<{ profileId: string }>();
  const profileId = profileIdParam ? decodeURIComponent(profileIdParam) : '';

  const { range } = useAppDateRange();
  const dateRange = range.current;
  const isDateRangeInvalid = !isRangeValid(dateRange);

  const { data: campaignsData } = useQuery({
    queryKey: ['profile-campaigns', profileId],
    queryFn: async () => {
      const res = await adsApi.fetchProfileCampaigns(profileId, null, {
        adProduct: 'ALL',
        status: 'ALL',
        search: '',
      });
      if (!res.success) throw new Error('Failed to load campaigns');
      return res.data;
    },
    enabled: Boolean(profileId),
    staleTime: 60_000,
  });

  const campaigns = useMemo(() => parseCampaignsPayload(campaignsData), [campaignsData]);

  return (
    <div className="mx-auto w-full max-w-[1600px] px-6 pb-8 pt-1">
      <header className="mb-4">
        <h1 className="text-2xl font-semibold text-foreground">Budget usage alerts</h1>
      </header>

      <BudgetUsageSection
        profileId={profileId}
        startDate={dateRange.startDate}
        endDate={dateRange.endDate}
        campaigns={campaigns}
        invalidRange={isDateRangeInvalid}
      />
    </div>
  );
}
